"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Pagination = exports.PageAction = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var component_library_1 = require("@kaizen/component-library");
var arrow_backward_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/arrow-backward.icon.svg"));
var arrow_forward_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/arrow-forward.icon.svg"));
var PageIndicator_1 = require("./PageIndicator");
var TruncateIndicator_1 = require("./TruncateIndicator");
var utils_1 = require("./utils");
var Pagination_module_scss_1 = __importDefault(require("./Pagination.module.scss"));
var PageAction;
(function (PageAction) {
    PageAction["PREV"] = "prev";
    PageAction["NEXT"] = "next";
})(PageAction = exports.PageAction || (exports.PageAction = {}));
/**
 * {@link https://cultureamp.design/components/pagination/ Guidance} |
 * {@link https://cultureamp.design/storybook/?path=/docs/components-pagination--default Storybook}
 */
var Pagination = function (_a) {
    var _b = _a.currentPage, currentPage = _b === void 0 ? 1 : _b, pageCount = _a.pageCount, ariaLabelNextPage = _a.ariaLabelNextPage, ariaLabelPreviousPage = _a.ariaLabelPreviousPage, ariaLabelPage = _a.ariaLabelPage, onPageChange = _a.onPageChange, classNameOverride = _a.classNameOverride, restProps = __rest(_a, ["currentPage", "pageCount", "ariaLabelNextPage", "ariaLabelPreviousPage", "ariaLabelPage", "onPageChange", "classNameOverride"]);
    // Click event for all pagination buttons (next, prev, and the actual numbers)
    var handleButtonClick = function (newPage) {
        if (newPage === PageAction.PREV) {
            onPageChange(currentPage - 1);
            return;
        }
        if (newPage === PageAction.NEXT) {
            onPageChange(currentPage + 1);
            return;
        }
        onPageChange(newPage);
    };
    var paginationIndicator = function (page) { return (react_1["default"].createElement(PageIndicator_1.PageIndicator, { key: page, page: page, selected: currentPage === page, ariaLabelPage: ariaLabelPage, onPageClick: handleButtonClick })); };
    var pagination = function () {
        var items = [];
        var boundaryPagesRange = 1;
        var siblingPagesRange = 1;
        // truncateSize is 1 now but could be 0 if we add the ability to hide it.
        var truncateSize = 1;
        var showAllPages = 1 + 2 * truncateSize + 2 * siblingPagesRange + 2 * boundaryPagesRange >=
            pageCount;
        // Simplify generation of pages if number of available items is equal or greater than total pages to show
        if (showAllPages) {
            return (0, utils_1.createRange)(1, pageCount).map(paginationIndicator);
        }
        else {
            // Calculate group of first pages
            var firstPagesStart = 1;
            var firstPagesEnd = boundaryPagesRange;
            var firstPages = (0, utils_1.createRange)(firstPagesStart, firstPagesEnd).map(paginationIndicator);
            // Calculate group of last pages
            var lastPagesStart = pageCount + 1 - boundaryPagesRange;
            var lastPagesEnd = pageCount;
            var lastPages = (0, utils_1.createRange)(lastPagesStart, lastPagesEnd).map(paginationIndicator);
            // Calculate group of main pages
            var mainPagesStart = Math.min(Math.max(currentPage - siblingPagesRange, firstPagesEnd + truncateSize + 1), lastPagesStart - truncateSize - 2 * siblingPagesRange - 1);
            var mainPagesEnd = mainPagesStart + 2 * siblingPagesRange;
            var mainPages = (0, utils_1.createRange)(mainPagesStart, mainPagesEnd).map(paginationIndicator);
            // Add group of first pages
            items.push.apply(items, firstPages);
            // Calculate and add truncate before group of main pages
            var firstEllipsisPageNumber = mainPagesStart - 1;
            var showPageInsteadOfFirstEllipsis = firstEllipsisPageNumber === firstPagesEnd + 1;
            items.push(showPageInsteadOfFirstEllipsis ? (paginationIndicator(firstEllipsisPageNumber)) : (react_1["default"].createElement(TruncateIndicator_1.TruncateIndicator, { key: firstEllipsisPageNumber })));
            // Add group of main pages
            items.push.apply(items, mainPages);
            // Calculate and add truncate after group of main pages
            var secondEllipsisPageNumber = mainPagesEnd + 1;
            var showPageInsteadOfSecondEllipsis = secondEllipsisPageNumber === lastPagesStart - 1;
            items.push(showPageInsteadOfSecondEllipsis ? (paginationIndicator(secondEllipsisPageNumber)) : (react_1["default"].createElement(TruncateIndicator_1.TruncateIndicator, { key: secondEllipsisPageNumber })));
            // Add group of last pages
            items.push.apply(items, lastPages);
        }
        return items;
    };
    var previousPageDisabled = currentPage <= 1;
    var nextPageDisabled = currentPage >= pageCount;
    return (react_1["default"].createElement("nav", __assign({ className: (0, classnames_1["default"])(Pagination_module_scss_1["default"].container, classNameOverride) }, restProps),
        react_1["default"].createElement("button", { type: "button", className: Pagination_module_scss_1["default"].arrowIconWrapper, "aria-label": ariaLabelPreviousPage, disabled: previousPageDisabled, onClick: function () { return handleButtonClick(PageAction.PREV); } },
            react_1["default"].createElement(component_library_1.Icon, { icon: arrow_backward_icon_svg_1["default"], role: "presentation" }),
            react_1["default"].createElement("div", { className: Pagination_module_scss_1["default"].pageIndicatorFocusRing })),
        react_1["default"].createElement("div", { className: Pagination_module_scss_1["default"].pagesIndicatorWrapper }, pagination()),
        react_1["default"].createElement("button", { type: "button", className: (0, classnames_1["default"])(Pagination_module_scss_1["default"].arrowIconWrapper, nextPageDisabled && Pagination_module_scss_1["default"].arrowIconWrapperDisabled), "aria-label": ariaLabelNextPage, disabled: nextPageDisabled, onClick: function () { return handleButtonClick(PageAction.NEXT); } },
            react_1["default"].createElement(component_library_1.Icon, { icon: arrow_forward_icon_svg_1["default"], role: "presentation" }),
            react_1["default"].createElement("div", { className: Pagination_module_scss_1["default"].pageIndicatorFocusRing }))));
};
exports.Pagination = Pagination;
//# sourceMappingURL=Pagination.js.map